export const PAGE_NAME_MAPPING = {
  'career-history': 'Career History',
  'skilldar': 'Skilldar',
  'career-courses': 'Career Courses',
  'colleges': 'Colleges',
  'regional-info': 'Regional Info',
  'landing-page': 'Landing Page',
  'privacy-policy': 'Privacy Policy',
  'terms-conditions': 'Terms & Conditions',
  'disclaimer': 'Disclaimer',
  'sign-up': 'Sign Up',
  'sign-in': 'Sign In',
  'forgotpassword': 'Forgot Password',
  'resetPassword': 'Reset Password',
  'widget': 'Widget'
};

export const getPageNameFromPath = (pathname) => {
  const pathSegments = pathname.split('/').filter(segment => segment);
  
  if (pathname.includes('/code')) return 'Have A Code';
  if (pathname.includes('/report')) return 'Report';
  if (pathname.includes('/widget')) return 'Widget';
  if (pathname.includes('/college-not-found')) return 'College Not Found';
  if (pathname === '/' || pathname === '') return 'Home Page';
  
  for (let i = pathSegments.length - 1; i >= 0; i -= 1) {
    const segment = pathSegments[i];
    if (PAGE_NAME_MAPPING[segment]) {
      return PAGE_NAME_MAPPING[segment];
    }
  }
  
  return 'Home';
};